/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Locate Icon component.
 */
export const MapLocateIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MapLocateIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M17.658 6.053a.5.5 0 00-.68-.566L3.672 10.95c-.47.193-.387.881.115.957l7.164 1.087a.5.5 0 01.398.332l2.35 6.855c.164.48.855.438.961-.058l2.999-14.07z'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round' />
      </svg>
    )} />
  );
};
